export default __webpack_public_path__ + "static/media/frenchflag.019747b9.webp";